<div class="block" #instagramFeed>
  <div class="elfsight-app-79a68b48-95ea-4044-a259-2cc284902ebc">
    <div class="loading">
      Récupération des dernières actualités...
    </div>
  </div>
</div>
